import { ConsigneeAddressType } from "@RequestFormV2/defaults/consigneeDefaults";

export type NotifyPartySyncOption =
  | "customAddressContact"
  | "sameAsConsigneeAddressContact"
  | "sameAsDeliveryAddressContact";

export interface NotifyPartyValue {
  address_type: ConsigneeAddressType;
  same_as_address_contact: NotifyPartySyncOption;
  form_address_contact_type: "custom" | "delivery" | "consignee";
  address_reference_number: string;
  address_id?: number;
  address_name: string;
  address_street: string;
  address_street_line2: string;
  address_city: string;
  address_state: string;
  address_country: string;
  address_zipcode: string;
  airport: string;
  airport_name: string;
  seaport: string;
  seaport_name: string;
  contact_name: string;
  contact_phone: string;
  contact_email: string;
}

export function getDefaultNotifyPartyValue(): NotifyPartyValue {
  return {
    address_type: "address",
    same_as_address_contact: "customAddressContact",
    form_address_contact_type: "custom",
    address_reference_number: "",
    address_name: "",
    address_street: "",
    address_street_line2: "",
    address_city: "",
    address_state: "",
    address_country: "",
    address_zipcode: "",
    airport: "",
    airport_name: "",
    seaport: "",
    seaport_name: "",
    contact_name: "",
    contact_phone: "",
    contact_email: "",
  };
}
